import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    API,
    BASE_URL,
    BROKER_EMAIL,
    BROKER_EMAIL_LOGO,
    BROKER_EMAIL_MASTHEAD,
    BROKER_NAME,
    EMAIL_API
} from "../../../../config";
import Profile from "./profile";
//import Statements from "./statements";
//import Trading from "./trading";
import KYCDocs from "./kyc_docs";
import SupportingDocs from "./supporting_docs";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import {Button, Icon, Typography} from '@material-ui/core';
//import Comms from "./comms";
import {connect} from "react-redux";
import Document from "../../../custom/Document";
import DocumentStatus from "./documentStatus";
import Utils from "../../../custom/utils";
import Confirmation from "./confirmation";
import Notes from "./notes";

const investor = API.service('investors');
const kyc_response = API.service('kyc-response');
const investorUploads = API.service('investors-uploaded-files');

const m = require('moment');
const axios = require('axios');

const styles = theme => ({
    heading1:{
        color:theme.colorPrimary
    },
    detail:{
        height:'100%',
        overflow:'auto'
    },
    detailContent:{
        margin:'8px 0',
        paddingTop:'10px'
    },
    tabs:{
        display:'inline-block',
        width:'100%',
        borderBottom:'2px solid #6a94ff',
        marginLeft:0,
        paddingLeft:0,

        '& li':{
            display:'inline-block',

            '& button':{
                //margin:'1px',
                padding:'6px 12px',
                backgroundColor:'#383c42',
                color:'white',
                lineHeight: '1.2em',
                fontSize: '1.1em',
                verticalAlign: 'text-bottom',

                '& div.kyc-label':{
                    lineHeight: '1.1em',
                    verticalAlign: 'text-bottom'
                }
            },
            '& button:hover':{
                backgroundColor:'#6a94ff',
            },
            '& button.active':{
                backgroundColor:'#6a94ff',
            }
        }
    },
    flex: {
        flex: 1,
    },

});

class ViewKYC extends Component {
    state={
        activeTab:'poid',
        investor:false,
        document:{},
        actions:{},
        actionLabel:'Accept',
        actionsPerformed:'',
        emailContent:'',
        comment:'',
        ids:{},
        lang:this.props.investor._language,
    }

    closeDetails = () => {
        this.props.context.update({
            drawerContent:false,
            drawerWidth:null
        })
    }

    componentDidMount() {
        this.loadInvestor(this.props.context.selectedInvestor);
    }

    loadInvestor = () => {
        if(this.props.investor !== 'new') {
            investor.find({query: {_id:this.props.investor._id, incl: 'compliance'}}).then(i => {
                console.log(i);
                this.setState({
                    investor: i.data[0]
                })
            })

            return true
        } else {
            this.setState({
                investor: 'new'
            })

            return true
        }
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.investor._id !== this.props.investor._id) {
            this.loadInvestor()
        }
    }

    changeTab = (e) => {
        console.log(e.target);
        this.setState({
            activeTab:e.target.id
        })
    }

    setDocState = (document, action) => {
        let actions = this.state.actions;

        actions[document] = action;

        let actionLabel = 'Approve';
        if(Object.keys(actions).length === 2){
            if(actions['_upload_id'] === actions['_upload_address']){
                actionLabel = actions['_upload_id'];
            } else if(actions['_upload_id'] === 'accept' &&  actions['_upload_address'] === 'approve'){
                actionLabel = 'accept';
            } else if(actions['_upload_id'] === 'approve' &&  actions['_upload_address'] === 'accept'){
                actionLabel = 'accept';
            } else {
                actionLabel = 'decline'
            }

            console.log(actions);
        }

        this.setState({
            actions:actions,
            actionLabel:actionLabel
        })
    }

    updateDocStatus = (answers, document, docid, currentState, action) => {
        console.log(answers,document,docid, currentState, action)
        let doc = this.state.document;
        let ids = this.state.ids;
        doc[document] = answers;
        ids[document] = docid;

        this.setState({
            document:doc,
            ids:ids,
        })

        this.setDocState(document, action);
    }

    popupConfirmation = () => {
        //send email content to component
        let content = (
          <Confirmation investor={this.props.investor} emailContent={this.state.emailContent} confirm={this.saveAndSend} updateComment={this.updateComment} comment={this.state.comment}/>
        );

        this.props.context.update({
            popupContent: content,
            popupTitle:"Confirmation",
            popupMaxWidth:"600px"
        })
    }

    saveAndSend = () => {
        const app = this;

        let newState = parseInt(this.props.investor._states,10);

        console.log(this.state.poidNewState, this.state.poadNewState);

        if(this.state.poidNewState === 'Not Accepted' || this.state.poadNewState === 'Not Accepted'){
            let mod = 0;

            if((this.props.investor._states & 1024 !== 0)){
                mod = mod + 1024
            }
            if(this.props.investor._states & 8){
                mod = mod - 8
            }
            if(this.props.investor._states & 128){
                mod = mod - 128
            }
            newState = parseInt(this.props.investor._states,10) + mod;
        }

        if (this.state.poidNewState === 'Approved' && this.state.poadNewState === 'Approved'){
          let mod = 0;

          if(!(this.props.investor._states & 128)){
            mod = mod + 128;
          }

          if(!(this.props.investor._states & 8)){
            mod = mod + 8
          }

          if((this.props.investor._states & 256)){
            mod = mod - 256
          }

          if((this.props.investor._states & 1024)){
            mod = mod - 1024
          }

          newState = parseInt(this.props.investor._states,10) + mod;
        }

        console.log("ANSWERS:",this.state.document['_upload_id'],this.state.document['_upload_address'], this.state.document);

        console.log({_new_status:this.state.poadNewState,_saved_question_answers:JSON.stringify(this.state.document['_upload_address'])});

        investorUploads.patch(this.state.ids['_upload_id'],{_new_status:this.state.poidNewState,_saved_question_answers:JSON.stringify(this.state.document['_upload_id'])},{query:{$limit:1}}).then(r=>{
            investorUploads.patch(this.state.ids['_upload_address'],{_new_status:this.state.poadNewState,_saved_question_answers:JSON.stringify(this.state.document['_upload_address'])},{query:{$limit:1}}).then(r=> {
                investor.patch(this.props.investor._id, {_states: newState }, {query: {$limit: 1}}).then(i => {
                    let comment = (this.state.comment !== '') ? '<p style=\'color:red;\'><strong>Additional message to Investor:</strong><br><br>{comment}</p>'.replace('{comment}', this.state.comment) : '';

                    //buildEmail
                    axios.post(EMAIL_API + '/requests', {
                        sender: 'Investor Portal',
                        payload: {
                            transportName: 'sendgrid',
                            to: this.props.investor._email,
                            from: BROKER_EMAIL,
                            subject: this.state.emailSubject,
                            templateName: 'kyc',
                            language: this.state.lang.toLowerCase(),
                            data: {
                                broker_email: BROKER_EMAIL,
                                broker_name: BROKER_NAME,
                                base_url: BASE_URL,
                                from: BROKER_EMAIL,
                                email_masthead: BROKER_EMAIL_MASTHEAD,
                                email_logo: BROKER_EMAIL_LOGO,
                                clientName: this.props.investor._firstname,
                                innerContent: this.state.emailContent.replace('{comment}', comment)
                            }
                        }
                    }).then(function (data) {
                        app.props.context.update({
                            popupContent: false,
                            kycUpdate:true,
                            drawerContent:false,
                        })
                    })
                })
            })
        })
    }

    updateComment = (comment) => {
        console.log('blah',comment)
        this.setState({
            comment:comment
        },this.saveAndSend)
    }

    performAction = () => {
        let action = '';
        let emailContent = '';
        //Change Document Statuses
        if(this.state.actions._upload_id === 'accept' && this.state.actions._upload_address === 'accept'){
            action += 'Set Poid to: ';
            action += 'Accepted';
            action += ' - Set Poad to: ';
            action += 'Accepted';

            //Set Investor State
            action += ' - Investor State Unchanged ';

            //Get Accepted Email Content
            kyc_response.find({query:{name:'Accepted', answerKey:'accepted',$limit:1,language:this.props.investor._language}}).then(email=>{
                 emailContent = email.data[0];

                 this.setState({
                     emailContent:email.data[0].content.replace('{brokername}',BROKER_NAME),
                     poidNewState:'Accepted',
                     poadNewState:'Accepted',
                     emailSubject:'Your KYC Documents have been Accepted'
                 },this.popupConfirmation)
            })
        }

        if(this.state.actions._upload_id === 'accept' && this.state.actions._upload_address === 'approve'){
            action += 'Set Poid to: ';
            action += 'Accepted';
            action += ' - Set Poad to: ';
            action += 'Accepted';

            //Set Investor State
            action += ' - Investor State Unchanged ';

            //Get Accepted Email Content
            kyc_response.find({query:{name:'Accepted', answerKey:'accepted',$limit:1,language:this.props.investor._language}}).then(email=>{
                emailContent = email.data[0];

                this.setState({
                    emailContent:email.data[0].content.replace('{brokername}',BROKER_NAME),
                    poidNewState:'Accepted',
                    poadNewState:'Accepted',
                    emailSubject:'Your KYC Documents have been Accepted'
                },this.popupConfirmation)
            })
        }

        if(this.state.actions._upload_id === 'approve' && this.state.actions._upload_address === 'accept'){
            action += 'Set Poid to: ';
            action += 'Accepted';
            action += ' - Set Poad to: ';
            action += 'Accepted';

            //Set Investor State
            action += ' - Investor State Unchanged ';

            //Get Accepted Email Content
            kyc_response.find({query:{name:'Accepted', answerKey:'accepted',$limit:1,language:this.props.investor._language}}).then(email=>{
                emailContent = email.data[0];

                this.setState({
                    emailContent:email.data[0].content.replace('{brokername}',BROKER_NAME),
                    poidNewState:'Accepted',
                    poadNewState:'Accepted',
                    emailSubject:'Your KYC Documents have been Accepted'
                },this.popupConfirmation)
            })
        }

        if(this.state.actions._upload_id === 'approve' && this.state.actions._upload_address === 'approve'){
            action += 'Set Poid to: ';
            action += 'Approved';
            action += ' - Set Poad to: ';
            action += 'Approved';

            //Set Investor State
            action += ' - Investor State Set to: ';
            action += (this.state.actions._upload_address === 'approve' && this.state.actions._upload_id === 'approve') ? 'Trading Approved' : '' ;

            //Get Approved Email Content
            kyc_response.find({query:{name:'Approved', answerKey:'approved',$limit:1,language:this.props.investor._language}}).then(email=>{
                emailContent = email.data[0];

                this.setState({
                    emailContent:email.data[0].content.replace('{brokername}',BROKER_NAME),
                    poidNewState:'Approved',
                    poadNewState:'Approved',
                    emailSubject:'Your KYC Documents have been Approved'
                },this.popupConfirmation)
            })
        }

        if(this.state.actions._upload_id === 'decline' && this.state.actions._upload_address === 'decline'){
            action += 'Set Poid to: ';
            action += (this.state.actions._upload_id === 'decline') ? 'Declined' : '' ;
            action += ' - Set Poad to: ';
            action += (this.state.actions._upload_address === 'decline') ? 'Declined' : '' ;

            //Set Investor State
            action += ' - Investor State Set to: ';
            action += (this.state.actions._upload_address === 'approve' && this.state.actions._upload_id === 'approve') ? 'Trading Approved' : '' ;

            //Send Rejected Email
            kyc_response.find({query:{name:'Declined', answerKey:'declined',$limit:1,language:this.props.investor._language}}).then(email=>{
                kyc_response.find({query:{name:'Declined', answerKey:'_upload_id',$limit:1,language:this.props.investor._language}}).then(iddesc=> {
                    kyc_response.find({query:{name:'Declined', answerKey:'_upload_address',$limit:1,language:this.props.investor._language}}).then(addesc=> {
                        let id_desc = iddesc.data[0].content;
                        let ad_desc = addesc.data[0].content;

                        //find reasons
                        let failid=0;
                        let failidanswer = '';
                        //Object.keys(this.state.document._upload_id).forEach(a => {
                        for (let a of Object.keys(this.state.document._upload_id)) {
                            if(this.state.document._upload_id[a] !== 'yes'){
                                failid=a;
                                failidanswer = this.state.document._upload_id[a];
                                break;
                            }
                        }

                        kyc_response.find({query:{questionId:failid, answerKey:failidanswer,$limit:1,language:this.props.investor._language}}).then(idreason=> {
                          console.log(idreason);
                            let failidreason = idreason.data[0].content;

                            let failadd=0;
                            let failaddanswer='';
                            for (let a of Object.keys(this.state.document._upload_address)) {
                                if(this.state.document._upload_address[a] !== 'yes'){
                                    failadd=a;
                                    failaddanswer = this.state.document._upload_address[a];
                                    break;
                                }
                            }

                            //console.log({questionId:failadd, answerKey:failaddanswer,$limit:1,language:this.props.investor._language});

                            kyc_response.find({query:{questionId:failadd, answerKey:failaddanswer,$limit:1,language:this.props.investor._language}}).then(addreason=> {
                                let failaddreason = addreason.data[0].content;

                                emailContent = email.data[0].content;

                                let reasonString = id_desc.replace('{reason}', failidreason) + ad_desc.replace('{reason}', failaddreason);

                                emailContent = emailContent.replace('{reason}',reasonString);
                                console.log('email content:',emailContent,reasonString, failidreason, failaddreason, id_desc, ad_desc);

                                this.setState({
                                    emailContent: emailContent.replace('{brokername}',BROKER_NAME),
                                    poidNewState:'Not Accepted',
                                    poadNewState:'Not Accepted',
                                    emailSubject:'Your KYC Documents have not been Accepted'
                                },this.popupConfirmation)
                            })
                        })
                    })
                })
            })
        }

        if(this.state.actions._upload_id !== 'decline' && this.state.actions._upload_address === 'decline'){

            //Send Rejected Email
            kyc_response.find({query:{name:'Declined', answerKey:'declined',$limit:1,language:this.props.investor._language}}).then(email=> {
                kyc_response.find({query: {name: 'Declined', answerKey: '_upload_address', $limit: 1}}).then(addesc => {
                    let ad_desc = addesc.data[0].content;

                    let failadd = 0;
                    let failaddanswer = '';
                    for (let a of Object.keys(this.state.document._upload_address)) {
                        if (this.state.document._upload_address[a] !== 'yes') {
                            failadd = a;
                            failaddanswer = this.state.document._upload_address[a];
                            break;
                        }
                    }

                    kyc_response.find({
                        query: {
                            questionId: failadd,
                            answerKey: failaddanswer,
                            $limit: 1,
                            language:this.props.investor._language
                        }
                    }).then(addreason => {
                        let failaddreason = addreason.data[0].content;

                        emailContent = email.data[0].content;

                        let reasonString = ad_desc.replace('{reason}', failaddreason);

                        emailContent = emailContent.replace('{reason}', reasonString);

                        this.setState({
                            emailContent: emailContent.replace('{brokername}',BROKER_NAME),
                            poidNewState:'Accepted',
                            poadNewState:'Not Accepted',
                            emailSubject:'Your KYC Documents have not been Accepted'
                        },this.popupConfirmation)
                    })
                })
            })
        }

        if(this.state.actions._upload_id === 'decline' && this.state.actions._upload_address !== 'decline'){
            action += 'Set Poid to: ';
            action += 'Declined'
            action += ' - Set Poad to: ';
            action += 'Accepted'

            //Set Investor State
            action += ' - Investor State Set to: ';
            action += (this.state.actions._upload_address === 'decline' || this.state.actions._upload_id === 'decline') ? 'KYC Returned' : '' ;

            console.log("DEBUG: ", {name:'Declined', answerKey:'declined',$limit:1,language:this.props.investor._language});
            console.log("DEBUG: ", {name: 'Declined', answerKey: '_upload_id', $limit: 1,language:this.props.investor._language});
            //Send Rejected Email
            kyc_response.find({query:{name:'Declined', answerKey:'declined',$limit:1,language:this.props.investor._language}}).then(email=> {
                kyc_response.find({query: {name: 'Declined', answerKey: '_upload_id', $limit: 1,language:this.props.investor._language}}).then(iddesc => {
                    let id_desc = iddesc.data[0].content;
                    let failid = 0;
                    let failidanswer = '';
                    //Object.keys(this.state.document._upload_id).forEach(a => {
                    for (let a of Object.keys(this.state.document._upload_id)) {
                        if (this.state.document._upload_id[a] !== 'yes') {
                            failid = a;
                            failidanswer = this.state.document._upload_id[a];
                            break;
                        }
                    }

                    kyc_response.find({
                        query: {
                            questionId: failid,
                            answerKey: failidanswer,
                            $limit: 1,
                            language:this.props.investor._language
                        }
                    }).then(idreason => {
                        console.log(idreason);
                        let failidreason = idreason.data[0].content;

                        emailContent = email.data[0].content;

                        let reasonString = id_desc.replace('{reason}', failidreason);

                        emailContent = emailContent.replace('{reason}', reasonString);

                        this.setState({
                            emailContent: emailContent,
                            poidNewState:'Not Accepted',
                            poadNewState:'Accepted',
                            emailSubject:'Your KYC Documents have not been Accepted'
                        },this.popupConfirmation)
                    })
                })
            })
        }

        this.setState({
            actionsPerformed:action
        })
    }

    investorState(state) {
        let InvStatus = Utils.returnState(state);
        return(
          <div className={'kyc-label ' + InvStatus[0]}>{InvStatus[1]}</div>
        )
    }

    render() {
        const {classes} = this.props;

        return (
            <div className={classes.detail + ' flex flex-col'} style={{height:'100vh'}}>
                <AppBar position="static">
                    <Toolbar>
                        <div className={classes.flex}>

                            <React.Fragment>
                                <div style={{width:40,height:40,borderRadius:'20px',overflow:'hidden',marginRight:'10px',display:'inline-block'}}>
                                    <Document investor={this.props.investor.acc} type='_avatar' label='Avatar' placeholder='/assets/images/profile/default_photo.jpg' hideReviewStatus={true} showImage={true} hideUpload={true} />
                                </div>
                                <div style={{height:50,display:'inline-block'}}>
                                    <Typography variant="title" color="inherit">
                                        {this.props.investor._surname}, {this.props.investor._firstname} {this.props.investor._middlename}  <span style={{marginLeft:'20px',marginTop:'15px'}}>{this.investorState(this.props.investor._states)}</span>
                                    </Typography>
                                    <Typography variant="subheading" color="inherit">
                                        {this.props.investor.acc}
                                    </Typography>
                                </div>
                            </React.Fragment>
                        </div>
                        <Button onClick={this.closeDetails} color={'inherit'}><FontAwesomeIcon icon="times" size="2x" /></Button>
                    </Toolbar>
                </AppBar>

                    <div style={{padding:20,paddingBottom:0,paddingTop:0}}>
                        {this.state.investor &&
                            <Profile investor={this.state.investor}/>
                        }

                        <div className={classes.detailContent} style={{position:'relative'}}>
                            <ul className={classes.tabs}>
                                <li>
                                    <button className={(this.state.activeTab === 'poid') ? 'active' : ''} onClick={this.changeTab} id={'poid'}>
                                        {(this.state.actions._upload_id === 'accept') &&
                                            <Icon style={{color:'#00ff00'}} className="text-14" color="action">done</Icon>
                                        }
                                        {(this.state.actions._upload_id === 'approve') &&
                                            <Icon style={{color:'#00ff00'}} className="text-14" color="action">done_all</Icon>
                                        }
                                        {(this.state.actions._upload_id === 'decline') &&
                                            <Icon style={{color:'#ff0000'}} className="text-14" color="action">clear</Icon>
                                        }
                                        &nbsp;Proof of Identity&nbsp;<DocumentStatus date={m(this.props.investor.poid_timestamp).format('DD MMM')} status={this.props.investor.poid_status}/>
                                    </button>
                                </li>
                                <li>
                                    <button className={(this.state.activeTab === 'poad') ? 'active' : ''} onClick={this.changeTab} id={'poad'}>
                                        {(this.state.actions._upload_address === 'accept' || (this.props.investor.poad_status === 'Accepted' && this.state.actions._upload_address !== 'approve')) &&
                                            <Icon style={{color:'#00ff00'}} className="text-14" color="action">done</Icon>
                                        }
                                        {(this.state.actions._upload_address === 'approve') &&
                                            <Icon style={{color:'#00ff00'}} className="text-14" color="action">done_all</Icon>
                                        }
                                        {(this.state.actions._upload_address === 'decline') &&
                                            <Icon style={{color:'#ff0000'}} className="text-14" color="action">clear</Icon>
                                        }
                                        &nbsp;Proof of Address&nbsp;<DocumentStatus date={m(this.props.investor.poad_timestamp).format('DD MMM')} status={this.props.investor.poad_status}/>
                                    </button>
                                </li>
                                <li>
                                    <button className={(this.state.activeTab === 'supporting') ? 'active' : ''} onClick={this.changeTab} id={'supporting'}>
                                        Supporting Documents
                                    </button>
                                </li>
                                <li>
                                    <button className={(this.state.activeTab === 'notes') ? 'active' : ''} onClick={this.changeTab} id={'notes'}>
                                        Notes
                                    </button>
                                </li>
                            </ul>
                            {(Object.keys(this.state.actions).length === 2) &&
                                <Button variant="contained" color="secondary" style={{position: 'absolute', top: 0, right: 0}} onClick={this.performAction}>{this.state.actionLabel}</Button>
                            }
                        </div>
                    </div>
                    <div className={'flex-1'} style={{overflow:'auto',padding:20,paddingTop:0}}>
                        {(this.state.activeTab === 'poid' && this.props.investor !== 'new' && this.state.investor !== false) &&
                            <KYCDocs investor={this.state.investor} document={'_upload_id'} documentTitle={'Proof of Identity'} updateState={this.updateDocStatus} />
                        }
                        {(this.state.activeTab === 'poad' && this.props.investor !== 'new' && this.state.investor !== false) &&
                            <KYCDocs investor={this.state.investor} document={'_upload_address'} documentTitle={'Proof of Address'} updateState={this.updateDocStatus} />
                        }
                        {(this.state.activeTab === 'supporting' && this.props.investor !== 'new') &&
                            <SupportingDocs investor={this.state.investor} document={'_supporting_document'} documentTitle={'Supporting Document'} hideQuestions={true} />
                        }
                        {(this.state.activeTab === 'notes' && this.props.investor !== 'new') &&
                            <Notes investor={this.state.investor} />
                        }
                    </div>
            </div>
        );
    }
}

function mapStateToProps({ fuse, auth }) {
    return {
        user: auth.user
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter((connect(mapStateToProps)(ViewKYC)))));
